import { bool, node, oneOfType, string } from "prop-types";

import FnrTypography from "FnrTypography";

const Label = ({ label, dark }) => {
  if (typeof label === "string") {
    return (
      <FnrTypography
        color={dark ? "textLight" : "textSecondary"}
        fontSize="lg"
        data-cy="FnrAccorion_DefaultLabel"
      >
        {label}
      </FnrTypography>
    );
  }
  return label;
};

Label.propTypes = { label: oneOfType([node, string]), dark: bool };

export default Label;
